/**
 * KAN-871: тексты блока "Мой Telegram" (личный Telegram-аккаунт менеджера)
 * в профиле приложения и подписи статуса аккаунта.
 */
export const PERSONAL_TELEGRAM_TEXTS = {
  title: "Мой Telegram",
  intro:
    "Подключите свой Telegram, чтобы писать клиентам от себя прямо из приложения.",
  connect: "Подключить",
  cancel: "Отмена",
  phoneLabel: "Номер телефона",
  getCode: "Получить код",
  codeLabel: "Код из Telegram",
  passwordLabel: "Облачный пароль",
  passwordHint:
    "В аккаунте включён облачный пароль (двухэтапная проверка). Введите его.",
  confirm: "Подтвердить",
  disconnect: "Отключить",
  disconnectQuestion: "Отключить личный Telegram?",
  disconnectNote:
    "Писать клиентам от себя станет нельзя. Переписка останется в карточках клиентов. Сеанс можно завершить и в Telegram: Настройки > Устройства.",
  hints: [
    "Код придёт в чат Telegram от служебного аккаунта Telegram, не по SMS.",
    "Не пересылайте код никому, даже себе в другой чат: Telegram отменит вход.",
    "После входа не закрывайте новый сеанс в Telegram: Настройки > Устройства.",
    "При первом сообщении клиенту, которого нет у вас в контактах, Telegram может на несколько секунд добавить его в контакты, потом он удаляется.",
    "Сообщения клиентам, написанные с телефона, в карточку клиента не попадут. Пишите из приложения.",
  ],
  startFailed: "Не удалось отправить код",
  confirmFailed: "Не удалось подтвердить вход",
  disconnectFailed: "Не удалось отключить Telegram",
  codeRequired: "Введите код из Telegram",
  passwordRequired: "Введите облачный пароль",
  loadFailed: "Не удалось загрузить состояние Telegram",
} as const;

const STATUS_TEXT: Record<string, string> = {
  connected: "Подключён",
  connecting: "Подключается",
  pending: "Подключается",
  disconnected: "Нет соединения",
  disabled: "Выключен",
  auth_lost: "Нет авторизации",
  unauthorized: "Нет авторизации",
};

/** Подпись статуса личного аккаунта; неизвестный статус как есть. */
export function personalTelegramStatusText(
  status: string | null | undefined,
): string {
  const key = (status ?? "").trim();
  return STATUS_TEXT[key] ?? (key || "Неизвестно");
}
